module.exports = __webpack_public_path__ + "img/scroll.2ef71bc3.gif";